<template>
  <div style="padding: 20px">
    <el-button type="primary" @click="addBase">添加基地</el-button>
    <el-table ref="table" :data="baseList">
      <el-table-column label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="基地名称" prop="baseName"> </el-table-column>
      <el-table-column label="纬度" width="85">
        <template slot-scope="scope">
          {{ scope.row.lat.toFixed(6) }}
        </template>
      </el-table-column>
      <el-table-column label="经度" width="85">
        <template slot-scope="scope">
          {{ scope.row.lon.toFixed(6) }}
        </template>
      </el-table-column>
      <el-table-column label="地址" prop="address"> </el-table-column>
      <el-table-column label="备注" prop="memo"> </el-table-column>
      <el-table-column label="图片" prop="image" width="160">
        <template slot-scope="scope">
          <img :src="imagePath + scope.row.image" width="150" height="150" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="editBase(scope.row)"
            plain
            >编辑</el-button
          >
          <el-button size="mini" type="danger" @click="delBase(scope.row)" plain
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-drag:common
      :visible="visible"
      :title="title"
      width="500px"
      @close="visible = false"
    >
      <el-form ref="form" :model="base" :rules="rules">
        <el-form-item prop="baseId" style="display:none">
          <el-input v-model="base.baseId" />
        </el-form-item>
        <el-form-item label="名称" prop="baseName">
          <el-input
            v-model="base.baseName"
            placeholder="请输入基地名称"
            style="width: 200px"
            :maxlength="80"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="lon">
          <el-input
            v-model="base.lon"
            placeholder="请输入经度"
            style="width: 200px"
            :maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="lat">
          <el-input
            v-model="base.lat"
            placeholder="请输入纬度"
            style="width: 200px"
            :maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="memo">
          <el-input
            v-model="base.memo"
            type="textarea"
            :rows="5"
            placeholder="请输入备注"
            style="width: 350px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            v-model="base.address"
            placeholder="请输入地址"
            style="width: 350px"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="image">
          <el-upload
            ref="upload"
            :action="action"
            :data="uploadParam"
            :auto-upload="false"
            :on-success="uploadSuccess"
            :limit="1"
            accept=".gif, .jpg, .png"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="saveBase">保存</el-button>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import isEmpty from 'lodash/isEmpty';
import { getToken } from '@/utils';
export default {
  data() {
    return {
      headers: {
        file: 'file',
        apiKey: getToken()
      },
      imagePath: process.env.VUE_APP_API_HOST + '/windfarm',
      action: `${process.env.VUE_APP_API_HOST_MANAGE}/manage/windfarm/saveBase`,
      title: '编辑基地',
      baseList: [],
      visible: false,
      base: {
        baseId: '',
        baseName: '',
        lat: '',
        lon: '',
        address: '',
        memo: ''
      },
      rules: {
        baseName: [{ required: true, message: '请填写基地名称' }],
        lat: [{ required: true, message: '请输入纬度' }],
        lon: [{ required: true, message: '请输入经度' }],
        address: [{ required: true, message: '请输入地址' }],
        memo: [{ required: true, message: '请填写备注' }]
      }
    };
  },
  async mounted() {
    await this.getBaseList();
  },
  computed: {
    uploadParam() {
      const param = { ...this.base, apiKey: getToken() };
      if (param.timestamp) {
        param.timestamp = this.$moment(param.timestamp).format(
          'YYYY-MM-DD HH:MM:SS'
        );
      }
      return param;
    }
  },
  methods: {
    uploadSuccess() {
      this.visible = false;
      this.$refs.form.resetFields();
      this.$refs.upload.clearFiles();
      this.$message({
        message: '上传成功',
        type: 'success'
      });
      this.getBaseList();
    },
    async getBaseList() {
      const res = await this.$fetch('/manage/windfarm/getBaseList', {
        module: 'manage',
        showError: true
      });
      this.baseList = res.data.data;
    },
    addBase() {
      this.editBase();
      this.title = '新增基地';
    },
    async delBase(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          await this.$postForm({
            url: '/manage/windfarm/delBase',
            module: 'manage',
            data: { baseId: row.baseId },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          this.getBaseList();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    async editBase(row) {
      this.title = '编辑基地';
      this.visible = true;
      this.base.baseName = row && row.baseName;
      this.base.lat = row && row.lat.toFixed(6);
      this.base.lon = row && row.lon.toFixed(6);
      this.base.address = row && row.address;
      this.base.memo = row && row.memo;
      this.base.baseId = (row && row.baseId) || '0';
    },

    async saveBase() {
      // await this.$fetch({
      //   url: '/manage/windfarm/saveBase',
      //   module: 'manage',
      //   method: 'post',
      //   data: {
      //     base:{
      //       baseName: this.baseName,
      //       lat: this.lat,
      //       lon: this.lon,
      //       address: this.address,
      //       memo: this.memo,
      //       image: this.image,
      //       baseId: (this.baseId) || '0',
      //     },
      //     file: this.file
      //   },
      //   showLoading: true,
      //   showError: true,
      //   showSuccess: true
      // });
      this.$refs.form.validate(valid => {
        if (isEmpty(this.$refs.upload.uploadFiles)) {
          this.$message({
            message: '请选择文件',
            type: 'error'
          });
          return;
        }
        if (valid) {
          this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
/deep/.el-form {
  padding: 10px;
  .el-form-item__label {
    color: #ffffff;
  }
}
/deep/.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    display: inline-block;
  }
}
</style>
